import styled from 'styled-components';

import { SizeUnit } from '@utils/types';

export const DrawerWrapper = styled.div`
  height: 100%;
`;

export const DrawerMask = styled.div<{ visible: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.15);
  z-index: 999;
  overflow: hidden;
  pointer-events: auto;
  display: ${({ visible }) => (visible ? 'block' : 'none')};
`;

export const StyledDrawer = styled.div<{
  visible: boolean;
  placement: string;
  width?: SizeUnit;
  height?: SizeUnit;
  animation?: 'topToBottom' | 'rightToLeft';
}>`
  position: fixed;
  top: 0;
  left: 0;
  width: ${({ width }) => (width ? width : '100%')};
  height: ${({ height }) => (height ? height : '100%')};
  background-color: ${({ theme }) => theme.palette.white};
  z-index: 1000;
  display: flex;
  flex-flow: column nowrap;

  animation: ${({ animation }) => {
    const base = '0.3s ease 0s 1 normal forwards';
    switch (animation) {
      case 'rightToLeft':
        return `rightToLeft ${base}`;
      case 'topToBottom':
      default:
        return `topToBottom ${base}`;
    }
  }};

  @keyframes topToBottom {
    0% {
      opacity: 0;
      transform: translateY(-50px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  @keyframes rightToLeft {
    0% {
      opacity: 0;
      transform: translateX(50px);
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;

export const StyledDrawerWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
  height: 100%;
`;

export const StyledDrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  position: relative;
  padding: 16px 20px;
  background-color: ${({ theme }) => theme.palette.white};
  border-bottom: 1px solid ${({ theme }) => theme.palette.lighterGray};
  border-radius: 2px 2px 0 0;
`;

export const StyledDrawerTitle = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-weight: bold;
  font-size: 16px;
`;

export const StyledDrawerBody = styled.div`
  flex-grow: 1;
  overflow: auto;
  background-color: ${({ theme }) => theme.palette.white};
  padding-top: 8px;
`;

export const CloseButton = styled.button`
  border: none;
  background: none;
`;
